import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// This app is served as a live dev build on the public domain.
// Avoid React.StrictMode here because its dev-only double mount can trigger
// duplicate startup side effects and transient red error overlays on reload.
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Only use the service worker in production. In dev, unregister so live updates work cleanly.
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register({
    onUpdate: () => {
      console.log('New version available! Please refresh.');
      // TODO: Show update notification to user
    },
    onSuccess: () => {
      console.log('App ready for offline use!');
    }
  });
} else {
  serviceWorkerRegistration.unregister();
}
